import React from "react";
import { WidgetContext, WidgetType, type WidgetId } from "./WidgetContext";

export const WidgetLoader: React.FC<{
  widgetType: WidgetType | "citation-group";
  widgetId?: WidgetId;
  widgetIds?: WidgetId[];
}> = ({ widgetType, widgetId, widgetIds }) => {
  const context = React.useContext(WidgetContext);

  if (!context) {
    throw new Error("WidgetLoader must be used within a WidgetProvider");
  }

  const { widgets } = context;

  // Handle citation-group with multiple IDs
  if (widgetType === "citation-group" && widgetIds) {
    const CitationWidget = widgets[WidgetType.Citation];
    if (!CitationWidget) {
      console.error("No citation widget found for citation-group");
      return null;
    }

    return (
      <CitationWidget
        values={{}} // Not used for grouped widgets
        id={widgetIds.join(",")} // Composite ID for React key
        ids={widgetIds} // Pass array of IDs
        type={WidgetType.Citation}
        messageId={context.messageId}
        chatId={context.chatId}
      />
    );
  }

  // Handle regular widgets with single ID
  if (!widgetId) {
    console.error("widgetId is required for non-grouped widgets");
    return null;
  }

  // At this point, widgetType is guaranteed to be WidgetType (not "citation-group")
  const actualWidgetType = widgetType as WidgetType;

  const Widget = widgets[actualWidgetType];
  if (!Widget) {
    console.error(`No widget found for type: ${actualWidgetType}`);
    return null;
  }

  const stateValues = context.widgetState?.[actualWidgetType]?.[widgetId] || {};

  return (
    <Widget
      values={stateValues}
      id={widgetId}
      type={actualWidgetType}
      messageId={context.messageId}
      chatId={context.chatId}
    />
  );
};
